import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../data/mock';
import { Flame, PartyPopper, Gamepad2 } from 'lucide-react';

const Experience = () => {
  const { t } = useLanguage();

  const experiences = [
    {
      icon: <Flame className="text-[#00FFD1]" size={32} />,
      title: t('exp1'),
      image: images.rooftopDogFirepit
    },
    {
      icon: <PartyPopper className="text-[#00FFD1]" size={32} />,
      title: t('exp2'),
      image: images.rooftopBalcony
    },
    {
      icon: <Gamepad2 className="text-[#00FFD1]" size={32} />,
      title: t('exp3'),
      image: images.indoor
    }
  ];

  return (
    <section className="bg-black py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          {t('experienceTitle')}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {experiences.map((exp, index) => (
            <div 
              key={index}
              className="relative group overflow-hidden cursor-pointer"
              style={{ aspectRatio: '4/3' }}
            >
              {/* Image */}
              <img 
                src={exp.image} 
                alt={exp.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
              
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3">
                  {exp.icon}
                  <h3 className="text-xl font-semibold text-white">{exp.title}</h3>
                </div>
              </div>
              
              {/* Hover border */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#00FFD1] transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
